export default __webpack_public_path__ + "static/media/arrow-right-solid.2db90993.svg";